import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from 'vuex-persist'

import navigationModule from "./modules/navigation";
import sessionNavigationModule from "./modules/session_navigation";
import configModule from "./modules/config";
import authModule from "./modules/auth";
import userModule from "./modules/user";
import videoChatModule from "./modules/videoChat";
import modal from "./modules/modal";

Vue.use(Vuex);


const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ['navigation', 'session_navigation'],
})
 
const store = new Vuex.Store({
  modules: {
    navigation: navigationModule,
    session_navigation: sessionNavigationModule,
    config: configModule,
    auth: authModule,
    user: userModule,
    videoChat: videoChatModule,
    modal: modal,
  },
  plugins: [vuexLocal.plugin],
});

export default store;
